/**
 * We do the best we can to resolve auth0 client name to domain, rely on common ai clients
 */
const CLIENT_DOMAINS_BY_KEYWORD: [keyword: string, domain: string][] = [
  ['claude', 'anthropic.com'],
  ['anthropic', 'anthropic.com'],
  ['chatgpt', 'openai.com'],
  ['openai', 'openai.com'],
  ['gemini', 'google.com'],
  ['google', 'google.com'],
  ['perplexity', 'perplexity.ai'],
  ['n8n', 'n8n.io'],
  ['glean', 'glean.com'],
  ['superhuman', 'superhuman.com'],
  ['gong', 'gong.io'],
  ['langsmith', 'langchain.com'],
  ['langchain', 'langchain.com'],
  ['amazon', 'amazon.com'],
  ['factory', 'factory.ai'],
  ['tines', 'tines.com'],
];

export function getClientDomain(
  client: string | null | undefined,
): string | undefined {
  const normalized = client?.toLowerCase();

  return CLIENT_DOMAINS_BY_KEYWORD.find(([keyword]) =>
    normalized?.includes(keyword),
  )?.[1];
}
